<h2 mat-dialog-title>Filters</h2>

<mat-dialog-content>
  <form [formGroup]="filterForm" id="form" (ngSubmit)="submit()">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Geologist</mat-label>
        <mat-select [formControl]="geologist">
          @for (geologist of geologistList; track geologist) {
            <mat-option value="{{ geologist }}">{{ geologist }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>Expedition</mat-label>
        <mat-select [formControl]="expedition">
          @for (expedition of expeditionList; track expedition) {
            <mat-option value="{{ expedition }}">{{ expedition }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </p>

    <mat-card class="npdc-leaflet" appearance="outlined">
      <app-leaflet-group
        [geometry]="location"
        [readonly]="false"
        [height]="'400px'"
        (geometryChange)="onGeoSearch($event)"
      />
    </mat-card>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button type="submit" form="form">Search</button>
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
